import BulkProduct from "./BulkProduct";
import ManageProduct from "./ManageProduct";
import Media from "./Media";

const ProductRoute = [
    {
        path: '/product/manage-product',
        parentRoute: '/product',
        component: ManageProduct,
    },
    {
        path: '/product/bulk-product',
        parentRoute: '/product',
        component: BulkProduct,
    },
    {
        path: '/product/media',
        parentRoute: '/product',
        component: Media,
    },
]

export default ProductRoute;
